"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Youtube = void 0;
var _react = _interopRequireDefault(require("react"));
var Youtube = exports.Youtube = function Youtube() {
  return _react["default"].createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: "#FF0000"
  }), _react["default"].createElement("path", {
    d: "M25 18.0001L11 10.0001V26.0001L25 18.0001Z",
    fill: "white"
  }));
};